import i18n from 'i18next';

class ErrorUnauthorized extends Error {}

function createAbortError() {
  const error = new Error('Request aborted');
  (error as any).isAbort = true;
  return error;
}

const apiWrapper = async (path: string, init?: RequestInit) => {
  const currentLanguage = i18n.language;

  try {
    const res = await fetch(`${path}`, init);

    if (res.status === 401) {
      throw new ErrorUnauthorized();
    }
    if (res.status !== 200) throw res;
    return res;
  } catch (err: unknown) {
    if (err instanceof DOMException) {
      throw createAbortError();
    }
    if (err instanceof ErrorUnauthorized) {
      location.href = '/api/v1/datainsight/auth/requestTokenInfo?lang=' + currentLanguage;
    }
    throw err;
  }
};

export { apiWrapper };
